module.exports = __webpack_public_path__ + "static/media/logo.7d6690a1.png";